import axios from '@/request/http'
import global from '@/constants/Global.constants'

export default {
  findAll () {
    return axios.post(global.BASE_INFO + '/system/findAll')
  },
  systemUpdate (params) {
    return axios.post(global.BASE_INFO + '/system/updateSystem', params)
  },
  systemStatusUpdate (params) {
    return axios.post(global.BASE_INFO + '/system/updateStatus', params)
  },
  systemInsert (params) {
    return axios.post(global.BASE_INFO + '/system/insertSystem', params)
  },
  systemSelect () {
    return axios.post(global.BASE_INFO + '/system/findSelect')
  },
  systemFindSystem () {
    return axios.post(global.BASE_INFO + '/system/findSystemId')
  }
}



// WEBPACK FOOTER //
// ./src/request/system/systemList.js